<script setup>
import { RichTextRenderer } from '@marvr/storyblok-rich-text-vue-renderer'

const props = defineProps({
  imageUrl: {
    type: String,
    default: '',
  },
  alt: String,
  description: {
    type: Object,
    default: () => {},
  },
  textColor: {
    type: String,
  },
  bgColor: {
    type: String,
  },
})

const textColorClasses = computed(() => {
  switch (props.textColor) {
    case 'yellow':
      return '!text-yellow-500'
    case 'blue':
      return '!text-blue-500'
    case 'green':
      return '!text-green-500'
    default:
      return '!text-secondary-red-100 '
  }
})
const bgColorClasses = computed(() => {
  switch (props.textColor) {
    case 'yellow':
      return '!bg-yellow-500'
    case 'blue':
      return '!bg-blue-500'
    case 'green':
      return '!bg-green-500'
    default:
      return '!bg-secondary-red-100 '
  }
})
</script>

<template>
  <div class="container">
    <div class="z-10 max-w-xl lg:max-w-[54rem]">
      <div
        :class="textColorClasses"
        class="flex items-center text-sm font-semibold uppercase lg:text-xl md:text-lg sm:text-md"
      >
        <span class="mr-4 h-[2px] w-6 lg:w-8 md:w-8" :class="bgColorClasses" />
        <slot name="header" />
      </div>
      <h1
        class="text-xl text-white uppercase sm:text-4xl xl:text-5xl xs:text-2xl lg:leading-[1.2]"
      >
        <slot name="title" />
      </h1>
      <div v-if="description" class="mb-0 mt-5 [&>*]:!text-white">
        <RichTextRenderer :document="description" />
      </div>
      <slot name="button" />
    </div>
  </div>
  <div
    class="bg-hero absolute inset-0 z-[-10]"
  >
    <div
      class="absolute inset-x-0 top-0 h-full w-full overflow-hidden opacity-40 lg:relative"
    >
      <div class="absolute inset-0 z-[3] h-full w-full bg-primary opacity-40 mix-blend-difference" />
      <div class="absolute inset-0 z-[2] h-full w-full bg-primary opacity-80 mix-blend-screen" />
      <nuxt-img v-if="imageUrl" width="1350" height="450" sizes="sm:375px md:1024px lg:1350px" :alt="alt" class="absolute inset-0 z-[1] h-full w-full object-cover object-center opacity-80" :src="imageUrl" />
    </div>
  </div>
  <div class="absolute inset-0 z-[-11] h-full w-full bg-primary" />
</template>
